<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0 bg-image px-10 py-14">
        <div class="flex flex-col">
            <h1 class="text-3xl font-bold text-white mb-5">First Astrology Platform based on AI Model</h1>
            <p class="text-lg font-medium text-gray-50">
                Get your hyper-personalised birth-chart using NASA planetary data on Vedic Astrology for most accurate and reliable AI-ML predictions.
            </p>

        </div>
        <div class="flex items-center justify-start gap-2 mt-32">
            <p-button label="Create Kundali" severity="primary" />
            <p-button label="Kundali Matching" severity="secondary" class="text-white" />
        </div>
    </div>
</div>